// Small DOM helpers shared by every part of the page.

export const el = <K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className: string,
  text = '',
): HTMLElementTagNameMap[K] => {
  const node = document.createElement(tag);
  node.className = className;
  node.textContent = text;
  return node;
};

export const button = (
  className: string,
  label: string,
  onPress: () => void,
): HTMLButtonElement => {
  const node = el('button', className, label);
  node.type = 'button';
  node.addEventListener('click', onPress);
  return node;
};

export const image = (className: string, src: string, alt: string): HTMLImageElement => {
  const node = el('img', className);
  node.src = src;
  node.alt = alt;
  node.draggable = false;
  return node;
};

const TAP_BUZZ_MS = 8;

// A short buzz under the finger, where the phone allows it (Android, not iOS).
export function buzz(ms = TAP_BUZZ_MS): void {
  try {
    navigator.vibrate?.(ms);
  } catch {
    // Some browsers throw when vibration is blocked.
  }
}

export const prefersLessMotion = (): boolean =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const readStore = (key: string): string => {
  try {
    return localStorage.getItem(key) ?? '';
  } catch {
    return '';
  }
};

export const writeStore = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Private mode or blocked storage: the value lasts as long as the tab.
  }
};
